<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="游玩类型" prop="store">
              <a-select
                default-value="lucy"
                style="width: 120px"
                @change="handleChange"
                v-model="formInline.store"
              >
                <a-select-option value="jack">全部</a-select-option>
                <a-select-option value="lucy">赠币</a-select-option>
                <a-select-option value="disabled"> 存票 </a-select-option>
                <a-select-option value="1"> 提币 </a-select-option>
                <a-select-option value="Yiminghe"> 入园 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="收支类型" prop="store">
              <a-select
                default-value="lucy"
                style="width: 120px"
                @change="handleChange"
                v-model="formInline.store"
              >
                <a-select-option value="jack">全部</a-select-option>
                <a-select-option value="lucy">收入</a-select-option>
                <a-select-option value="disabled"> 支付 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="游玩记录" prop="store">
              <a-input placeholder="请选择游玩时间" type="text" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <playRecordContent></playRecordContent>
      </div>
    </a-layout-content>
    <a-button type="primary" style="margin: 16px" @click="btns">
      <a-icon type="left" />返回</a-button
    >
  </div>
</template>

<script>
import playRecordContent from "./playRecordContent.vue";

export default {
  components: {
    playRecordContent,
  },
  data() {
    return {
      formInline: {
        user: "",
        password: "",
        store: "",
      },
    };
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
    },
    btns() {
      this.$router.push("/home/memberManagement/memberManagementTop");
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/memberManagement/playRecord/playRecord.vue